import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export function login (data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function getInfo () {
  if (getToken()) {
    return request({
      url: '/auth/check',
      method: 'get'
      // params: { token }
    })
  }
}

export function logout () {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}

export function forgotPass (data) {
  return request({
    url: '/auth/forgotPass',
    method: 'post',
    data
  })
}

export function confirmForgotPass (data) {
  return request({
    url: '/auth/confirmForgotPass',
    method: 'post',
    data
  })
}

//issue 679
export function changePassword (data) {
  return request({
    url: '/auth/changePassword',
    method: 'post',
    data
  })
}
//issue 679

export function getConfig() {
  const ret = request({
    url: '/config',
    method: 'get'
  })
  return ret  
}